// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1uIPo","buttons":"RemoveExpirationActionButtons_buttons__2DhK-"};